module.exports = __webpack_public_path__ + "img/hongdou.bb84ee2d.jpg";